import { Breadcrumbs, fabClasses, Link, Stack, TablePagination, Typography } from "@mui/material";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import { useItensChecklistViewModel } from "../../viewModels/item_checklist_lista_view_model";
import RefreshButton from "../../../../../common/components/refresh_button";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { GenerateItemsChecklistColumnDefinition } from "./columns";
import { useMemo } from "react";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { ItemChecklistLista } from "../../../domain/models/ItemChecklistLista";
import { ModalItensChecklistLista } from "./components/modal_create";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { BackButton } from "../../../../../common/components/back_button";

export const ChecklistItensCadastro = () => {
  const viewModel = useItensChecklistViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateItemsChecklistColumnDefinition({
      onActionDeletar: viewModel.DeleteOpenModal,
      onActionEditar: viewModel.handleModalOpenState,
    });
  }, [viewModel.DeleteOpenModal, viewModel.handleModalOpenState]);
  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <div className="w-[130px] ">
                <PrimaryButton
                  onClick={() => viewModel.handleModalOpenState(null, true)}
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                >
                  Novo Item
                </PrimaryButton>
              </div>
              <BackButton onClick={() => viewModel.handleVoltar()} />
            </div>
          }
        />
      </PageTopBar>
      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Projetos
          </Link>
          <Link underline="hover" color="inherit">
            Lista de Checklist
          </Link>
          <Typography className="text-primary-green">Itens do Checklist </Typography>
        </Breadcrumbs>

        <div className="flex gap-2 items-center w-full">
          <h1 className="text-3xl font-medium text-black dark:text-white">Itens do Checklist </h1>
          <RefreshButton onClick={viewModel.handleReload} />
        </div>
        <StyledDataGrid
          tableName="Item Checklist"
          disableColumnMenu={false}
          showToolbar={true}
          disableRowSelectionOnClick={true}
          getRowId={(row: ItemChecklistLista) => row.IdItemChecklist}
          columns={columnsDefinition}
          loading={viewModel.loading}
          checkboxSelection={false}
          rows={viewModel.itemChecklistLista}
          rowCount={viewModel.itemChecklistLista.length}
          pageSizeOptions={[10, 25, 50, 100]}
          paginationMode="server"
          paginationModel={{
            page: viewModel.pagination.page,
            pageSize: viewModel.pagination.rowsPerPage,
          }}
          pinnedColumns={{
            right: ["IdItemChecklist"],
          }}
        />

        <TablePagination
          component="div"
          count={viewModel.pagination.totalItems}
          page={viewModel.pagination.page - 1}
          onPageChange={(_, p) => viewModel.handlePageChange(p)}
          rowsPerPageOptions={[10, 25, 50, 100]}
          rowsPerPage={viewModel.pagination.rowsPerPage}
          onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
        />

      </div>

      <ModalItensChecklistLista
        open={viewModel.itemChecklistModal}
        saving={viewModel.saving}
        onClose={() => viewModel.setItemChecklistModal(false)}
        onSubmit={viewModel.handleCheckListSubmit}
        onOpenChangeHistory={(id, tabelaTipo) => viewModel.handleOpenChangeHistory(id, tabelaTipo)}
        selectedItemChecklist={viewModel.selectedItemChecklist} />

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

      <DeleteDialog
        open={viewModel.openDeleteModal}
        onClose={() => viewModel.DeleteOpenModal(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.DeletarItemCheckList}
      />
    </>
  );
};
